import React, { useState, useEffect } from "react";
import ViewInvoiceModal from "../Invoice List/ViewInvoiceModal"; 
import API_BASE_URL from "../../../../Constants";

const InvoiceTable = ({ setFormData, setInvoiceID }) => {
  const [invoices, setInvoices] = useState([]);
  const [selectedInvoiceId, setSelectedInvoiceId] = useState(null);
  const [isViewOpen, setIsViewOpen] = useState(false);

  useEffect(() => {
    const fetchInvoices = async () => {
      try {
        const response = await fetch(API_BASE_URL + "/api/invoice/all", {
          method: 'GET',
          credentials: 'include', 
        });

        if (!response.ok) {
          throw new Error("Error fetching invoices");
        }

        const data = await response.json();
        setInvoices(Array.isArray(data) ? data : []);
      } catch (error) {
        console.error("Error fetching invoices:", error);
        setInvoices([]);
      }
    };


    fetchInvoices();
  }, []);

  const handleOpenViewModal = (invoiceId) => {
    setSelectedInvoiceId(invoiceId);
    setIsViewOpen(true);
  };

  const handleCloseViewModal = () => {
    setIsViewOpen(false);
    setSelectedInvoiceId(null);
  };

  if (!Array.isArray(invoices)) {
    return <p>Error: The invoice data could not be loaded properly.</p>;
  }

  return (
    <div className="mx-auto pl-4 pr-4 w-full mt-10">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-2xl font-bold">Invoices</h2>
      </div>
      <div className="overflow-x-auto">
        <table className="min-w-full bg-white border-2 border-gray-200 rounded-lg shadow-lg">
          <thead className="bg-gray-200">
            <tr>
              <th className="py-3 px-4 text-left font-bold text-sss-blue-sel">Actions</th>
              <th className="py-3 px-4 text-left font-bold text-sss-blue-sel">Invoice Number</th>
              <th className="py-3 px-4 text-left font-bold text-sss-blue-sel">Invoice Date</th>
              <th className="py-3 px-4 text-left font-bold text-sss-blue-sel">Customer</th>
              <th className="py-3 px-4 text-right font-bold text-sss-blue-sel">Invoice Amount</th>
              <th className="py-3 px-4 text-right font-bold text-sss-blue-sel">Parts Amount</th>
              <th className="py-3 px-4 text-right font-bold text-sss-blue-sel">Discount Amount</th>
              <th className="py-3 px-4 text-right font-bold text-sss-blue-sel">Tax Amount</th>
              <th className="py-3 px-4 text-right font-bold text-sss-blue-sel">Open</th>
            </tr>
          </thead>
          <tbody className="text-gray-700">
            {invoices.length > 0 ? (
              invoices.map((invoice, index) => (
                <tr
                  key={index}
                  className={`${index % 2 === 0 ? "bg-white" : "bg-gray-50"
                    } hover:bg-gray-100 transition-colors`}
                >
                  <td className="py-3 px-4 border-b">
                    <button
                      className="text-sss-blue-sel hover:text-yellow-500 font-bold transition duration-300 ease-in-out"
                      onClick={() => handleOpenViewModal(invoice.invoiceID)}
                    >
                      View
                    </button>
                  </td>
                  <td className="py-3 px-4 border-b">{invoice.invoiceNumber}</td>
                  <td className="py-3 px-4 border-b">{invoice.invoiceDate}</td>
                  <td className="py-3 px-4 border-b">{invoice.customer}</td>
                  <td className="py-3 px-4 border-b text-right">{invoice.invoiceAmount.toFixed(2)}</td>
                  <td className="py-3 px-4 border-b text-right">{invoice.partsAmount.toFixed(2)}</td>
                  <td className="py-3 px-4 border-b text-right">{invoice.discountAmount.toFixed(2)}</td>
                  <td className="py-3 px-4 border-b text-right">{invoice.taxAmount.toFixed(2)}</td>
                  <td className="py-3 px-4 border-b text-right">
                    {invoice.isOpen ? "Open" : "Closed"}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="9" className="py-3 px-4 text-center text-gray-500 border-b">
                  No invoices found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* View Invoice Modal */}
      {selectedInvoiceId && (
        <ViewInvoiceModal
          open={isViewOpen}
          handleClose={handleCloseViewModal}
          invoiceId={selectedInvoiceId}
        />
      )}
    </div>
  );
};

export default InvoiceTable;
